module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/logo_c04-39078194a2bc2f6581f0bbb0f9c7612d.jpg";